
import styled from "styled-components";
export const Container = styled.div`
  height: 60vh;
  padding-bottom: 25px;

  .table-list-body {
    padding: 5px;
  }

  #snackbar {
    justify-content: center;
  }
`;

export const Header = styled.div`
  display: flex;
`;

export const Title = styled.h1`
  margin: 0;
  align-self: center;
  font-weight: var(--font-weight-medium);
  padding-left: 25px;
  font-size: 22px;
`;

export const DateSpan = styled.h1`
  background-color: var(--color-neutral-200);
  color: var(--color-action-default);
  border-radius: 50px;
  padding: 1px 50px 0px 50px;
  font-size: 15px;
  margin-left: auto;
  font-weight: 550;
`;

export const ContainerActions = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: right;
  padding-right: 35px;

  .buttons {
    width: 200px;
    margin: 15px 15px 15px 15px;
  }
`;
